import CreatableSelect from 'react-select/creatable';
import { useTranslation } from 'react-i18next';

export const CreatableCustomSelect = ({ loading, categories = [], formik, isDisabled = false, inputId }) => {
    const { t } = useTranslation();

    const customSelectStyles = {
        dropdownIndicator: (base) => ({ ...base, color: 'rgb(157, 157, 157)' }),
        control: (base) => ({
            ...base,
            border: '0',
            boxShadow: 'none',
            backgroundColor: '#f9f9f9',
            '&:hover': {
                border: '0',
            },
        }),
        option: (styles, { isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: isSelected || isFocused ? '#e0e1e3' : '#f9fafb',
                color: isSelected || isFocused ? '#fff' : '#000',
            };
        },
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: 14,
            fontWeight: 500,
            color: '#9a9ab0',
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: 14,
            fontWeight: 500,
        }),
    };

    const onSelectChange = (categories) => {
        formik.setFieldValue('categories', categories);
    };

    return (
        <>
            <CreatableSelect
                name="category"
                inputId={inputId}
                className="text-left w-full mr-2.5"
                onChange={(value) => onSelectChange(value)}
                isLoading={loading}
                isDisabled={isDisabled}
                getOptionLabel={(opt) => opt.name}
                getOptionValue={(opt) => opt.id}
                options={categories}
                value={formik.values.categories}
                placeholder={t('Type to search or create a category')}
                isSearchable
                isMulti
                styles={customSelectStyles}
            />
        </>
    );
};
